import React from "react";
import { capitalize } from "../../services/Utils";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import ConfigurationStatus from "./ConfigurationStatus";
import PublishConfiguration from "./PublishConfiguration";
import { min } from "date-fns";

const getColumnsData = () => {
  return [
    {
      field: "configName",
      headerName: "Configuration Name",
      flex: 2,
      minWidth: 250,
      editable: false,
    },
    {
      field: "vehicleNos",
      headerName: "Vehicle Nos",
      flex: 0.75,
      minWidth: 150,
      editable: false,
    },
    {
      field: "createdBy",
      headerName: "Created by",
      sortable: true,
      minWidth: 150,
      flex: 0.75,
      valueFormatter: ({ value }) => capitalize(value),
    },
    {
      field: "campaignCreationDate",
      headerName: "Created On",
      sortable: true,
      flex: 0.75,
      minWidth: 150,
      type: "dateTime",
      valueGetter: (value) => value ? new Date(value) : null,
      renderCell: (data) => <DateAndTimeGridCell {...data} />,
    },
    {
      field: "configStatus",
      headerName: "Status",
      flex: 0.75,
      headerAlign: "center",
      align: "center",
      minWidth: 250,
      editable: false,
      renderCell: (data) => {
        return <ConfigurationStatus status={data.row.configStatus} />;
      },
    },
    {
      field: "empty",
      headerName: "Actions",
      flex: 1,
      minWidth: 250,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (data) => {
        return <PublishConfiguration data={data} />;
      },
    },
  ];
};

export { getColumnsData };
